import SatelliteIcon from '@apps-common/ui-icons/Satellite.jsx';
import {Box, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useSelector} from 'react-redux';

import {getDisplayName} from '@explorer/selectors/item-types';

export const ItemTypeIcon = props => (
  <SatelliteIcon sx={{marginRight: 0.5}} {...props} />
);

const ItemType = ({
  itemType,
  typographyProps,
  showIcon = true,
  suffix = '',
  ...props
}) => {
  const itemTypeLabel = useSelector(state => getDisplayName(state, itemType));
  return (
    <Box
      title={itemTypeLabel}
      data-qe="item-type-label"
      {...props}
      sx={[
        {
          display: 'flex',
          alignItems: 'center',
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {showIcon && (
        <ItemTypeIcon
          fontSize="small"
          sx={{
            fontSize: 18,
            marginRight: 0.5,
          }}
        />
      )}
      <Typography
        noWrap
        component="span"
        data-qe="item-type-header"
        {...typographyProps}
      >
        {itemTypeLabel}
        {suffix ? ` ${suffix}` : ''}
      </Typography>
    </Box>
  );
};

ItemType.propTypes = {
  itemType: PropTypes.string,
  typographyProps: PropTypes.object,
  showIcon: PropTypes.bool,
  suffix: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default ItemType;
